export enum GoalType {
  Goal = 'goal',
  Project = 'project',
}
